import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
	import { LControlScale, LMap, LTileLayer,LMarker } from 'vue2-leaflet';

	import { MarkerIcon } from './marker-icon';
	import { Structure } from '@/types/structure';
	import { GeoApiCity } from '@/types/geo-api-city';
	import { isFromCard, selectedStructureId } from '../../store/store';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'structures-map',
  props: {
    structureList: null,
    city: null
  },
  setup(__props: any) {

const props = __props as {
		structureList: Structure[];
		city: GeoApiCity;
	};

	const blueIcon = new MarkerIcon('./img/marker-icon-2x-blue.png');
	const redIcon = new MarkerIcon('./img/marker-icon-2x-red.png');

	// MAP URLs
	const url = 'https://data.geopf.fr/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2&STYLE=normal&FORMAT=image/png&TILEMATRIXSET=PM&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}';
	const attribution = '&copy; <a href="https://www.ign.fr/">IGN</a> - Géoplateforme';

	const mapOptions = {
		zoomSnap: 0.5
	};
	const INITIAL_ZOOM_MAP = 12;

	

	const zoom = ref(INITIAL_ZOOM_MAP);

	const center = ref<number[]>([props.city.centre.coordinates[1], props.city.centre.coordinates[0]]);

	const selectedStructure = computed(() => props.structureList.find(s => s.id === selectedStructureId.value));

	/**
	 * Recentre la carte lorsque l'utilisateur clique sur une tuile
	 */
	watch(selectedStructureId, () => {
		if (isFromCard.value && selectedStructureId.value && selectedStructure.value) {
			center.value = [selectedStructure.value.address.latitude, selectedStructure.value.address.longitude];
		}
	});

	/**
	 * Recentre la carte lorsque l'utilisateur fait une nouvelle recherche
	 */
	watch([() => props.structureList, selectedStructureId], () => {
		if (!selectedStructureId.value) {
			center.value = [props.city.centre.coordinates[1], props.city.centre.coordinates[0]];
		}
	});

	/**
	 * Sélectionne la structure
	 * @param structureId id de la structure
	 */
	function handleSelectMarker(structureId: number): void {
		isFromCard.value = false;
		selectedStructureId.value = structureId;
	}

	/**
	 * Retourne l'icône
	 */
	function getIcon(structure: Structure): MarkerIcon | undefined {
		const isSelected = selectedStructure.value &&
			structure.address.latitude === selectedStructure.value.address.latitude &&
			structure.address.longitude === selectedStructure.value.address.longitude;

		return isSelected ? redIcon : blueIcon;
	}

	/**
	 * Retourne une valeur en fonction de la distance de la première structure trouvée
	 *
	 * @returns le zoom par défaut
	 */
	watch(() => props.structureList, () => {
		const distanceFirstStructure = props.structureList[0].address.distance;

		// constantes pour les distances
		const DISTANCE_MAX_45 = 45;
		const DISTANCE_MAX_25 = 25;
		const DISTANCE_MAX_10 = 10;
		const DISTANCE_MAX_0 = 0;

		// constantes pour les niveaux de zoom
		const ZOOM_VALUE_8 = 8;
		const ZOOM_VALUE_10 = 10;
		const ZOOM_VALUE_11 = 11;
		const DEFAULT_ZOOM_VALUE = 12;

		let zoomValue = DEFAULT_ZOOM_VALUE;
		if (distanceFirstStructure) {
			switch (true) {
				case distanceFirstStructure > DISTANCE_MAX_45:
					zoomValue = ZOOM_VALUE_8;
					break;

				case distanceFirstStructure > DISTANCE_MAX_25:
					zoomValue = ZOOM_VALUE_10;
					break;

				case distanceFirstStructure > DISTANCE_MAX_10:
					zoomValue = ZOOM_VALUE_11;
					break;

				case distanceFirstStructure > DISTANCE_MAX_0:
					zoomValue = DEFAULT_ZOOM_VALUE;
					break;

				default:
					zoomValue = DEFAULT_ZOOM_VALUE;
			}
		}
		zoom.value = zoomValue;
	}, {
		immediate: true
	});


return { __sfc: true,blueIcon, redIcon, url, attribution, mapOptions, INITIAL_ZOOM_MAP, props, zoom, center, selectedStructure, handleSelectMarker, getIcon, LControlScale, LMap, LTileLayer, LMarker }
}

})